import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { ImagePreview } from './ImagePreview.js';
import { MissionDetailTable } from './MissionDetailTable.js';
import { Timeline } from './Timeline.js';
import Box from '@mui/material/Box';
import { CsvDownloadButton } from './CsvDownloadButton.js';
import { SlideShow } from './SlideShow.js';
import { MainBox } from './MainBox.js';
import { VideoPreview } from './VideoPreview.js';
import { OGPLoad } from './OGPLoad.js';

const MissionPage = ({
  item
}) => {
  var _item$countdown, _item$countdown2, _item$extra_links;
  const ImageDialog = () => /*#__PURE__*/React.createElement(ImagePreview, {
    src: item.image_url,
    alt: 'thumbnail'
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    sx: {
      textAlign: 'center'
    }
  }, "Image Credit: ", item.image_credit));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MainBox, {
    sx: {
      p: 0
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    display: {
      xs: 'none',
      lg: 'block'
    }
  }, /*#__PURE__*/React.createElement(ImageDialog, null)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    lg: 6,
    sx: {
      p: 2
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    sx: {
      fontWeight: 'bold',
      mt: 3,
      mb: 3,
      pl: 1
    }
  }, item.title), /*#__PURE__*/React.createElement(MissionDetailTable, {
    item: item
  })))), /*#__PURE__*/React.createElement(MainBox, {
    sx: {
      p: 0
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6,
    sx: {
      borderRight: '1px solid #eee'
    }
  }, item.watch_URL ? /*#__PURE__*/React.createElement(VideoPreview, {
    url: item.watch_URL,
    title: "\u4E2D\u7D99 / \u30A2\u30FC\u30AB\u30A4\u30D6\u52D5\u753B",
    seek_offset: item.watch_URL_liftoff_at
  }) : /*#__PURE__*/React.createElement(Typography, null, "\u4E2D\u7D99 / \u30A2\u30FC\u30AB\u30A4\u30D6\u52D5\u753B\u306F\u3042\u308A\u307E\u305B\u3093")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6,
    sx: {
      borderRight: '1px solid #eee'
    }
  }, item.watch_URL_short ? /*#__PURE__*/React.createElement(VideoPreview, {
    url: item.watch_URL_short,
    title: "\u5207\u308A\u629C\u304D\u52D5\u753B"
  }) : /*#__PURE__*/React.createElement(Typography, null, "\u5207\u308A\u629C\u304D\u52D5\u753B\u306F\u3042\u308A\u307E\u305B\u3093")))), item.slide && /*#__PURE__*/React.createElement(MainBox, {
    sx: {
      p: 0
    }
  }, /*#__PURE__*/React.createElement(SlideShow, {
    images: item.slide.paths
  })), (((_item$countdown = item.countdown) == null ? void 0 : _item$countdown.t_minus) || ((_item$countdown2 = item.countdown) == null ? void 0 : _item$countdown2.t_plus)) && /*#__PURE__*/React.createElement(MainBox, {
    sx: {
      p: 0
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6,
    sx: {}
  }, /*#__PURE__*/React.createElement(Timeline, {
    countdown: item.countdown,
    mode: "t_minus",
    datetime: item.datetime,
    datetime_confirmed: item.datetime_time_type === 'CONFIRMED'
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6,
    sx: {
      border: '1px solid #eee'
    }
  }, /*#__PURE__*/React.createElement(Timeline, {
    countdown: item.countdown,
    mode: "t_plus",
    datetime: item.datetime,
    datetime_confirmed: item.datetime_time_type === 'CONFIRMED'
  }))), /*#__PURE__*/React.createElement(Box, {
    sx: {
      textAlign: 'right',
      p: 1
    }
  }, /*#__PURE__*/React.createElement(CsvDownloadButton, {
    variant: "outlined",
    headers: ['type', 'timestamp', 'datetime', 'content'],
    rows: [...(item.countdown.t_minus || []).map(c => ['T-', c.timestamp, c.datetime, c.content]), ...(item.countdown.t_plus || []).map(c => ['T+', c.timestamp, c.datetime, c.content])],
    filename: "countdown.csv"
  }, "CSV\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9"))), /*#__PURE__*/React.createElement(MainBox, {
    sx: {
      p: 0
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    display: {
      xs: 'none',
      md: 'block'
    },
    sx: {
      p: 1
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    component: "h2",
    "aria-label": "\u95A2\u9023\u30EA\u30F3\u30AF"
  }, "\u95A2\u9023\u30EA\u30F3\u30AF")), !((_item$extra_links = item.extra_links) != null && _item$extra_links.length) && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sx: {
      p: 2,
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(Typography, null, "\u95A2\u9023\u30EA\u30F3\u30AF\u306F\u3042\u308A\u307E\u305B\u3093")), (item.extra_links || []).map(link => /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4,
    sx: {
      p: 1
    },
    key: link.url
  }, /*#__PURE__*/React.createElement(OGPLoad, {
    key: link.url,
    url: link.url,
    image_height: "100"
  }))))));
};

export { MissionPage, MissionPage as default };
